module.exports = __webpack_public_path__ + "f3373d964eac6615397e1154c438246f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/atty-general.png
// module id = 1027
// module chunks = 0